// extracted by mini-css-extract-plugin
export default {"field":"SwitchField_field__o41Q5","label":"SwitchField_label__s-znl","description":"SwitchField_description__5Jb1w"};